module.exports = __webpack_public_path__ + "img/bay2.918984db.jpg";